module.exports = JSON.parse('{"Tracked series":"{{trackedSeries}} Test Tracked series"}')